import React from 'react';
import './scrimStyles.css';

const toDate = (value) => {
  if (!value) return null;
  if (value.toDate) return value.toDate();
  if (value instanceof Date) return value;
  return null;
};

const formatTimeLabel = (date) => {
  if (!date) return '';
  return new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};

const ScrimChip = ({ scrim, onClick, timeLabel, isLive, isPast }) => {
  const { title } = scrim;
  const statusLabel = scrim.replaced
    ? 'REPLACED'
    : scrim.cancelled
    ? 'CANCELLED'
    : null;
  const eventLabel = scrim.eventType
    ? scrim.eventType.replace('-', ' ').toUpperCase()
    : 'EVENT';
  const chipLabel = statusLabel || eventLabel;
  const chipClass = statusLabel ? statusLabel.toLowerCase() : scrim.eventType || 'event';
  const startAt = toDate(scrim.startAt);
  const endAt = toDate(scrim.endAt);
  const fallbackTimeLabel =
    scrim.allDay
      ? 'All day'
      : startAt && endAt
      ? `${formatTimeLabel(startAt)} - ${formatTimeLabel(endAt)}`
      : '';
  const displayTime = timeLabel || fallbackTimeLabel || 'Time TBD';
  const plannedContent = scrim.plannedContent || scrim.actualContent || scrim.mapPool || '';
  const note = scrim.note || '';
  const opponent = scrim.opponent ? `Opponent: ${scrim.opponent}` : '';
  const liveLabel = isLive ? 'LIVE' : null;
  const pastLabel = isPast && !statusLabel ? 'PAST' : null;
  const stateLabel = liveLabel || pastLabel;

  return (
    <div
      className={`scrim-chip scrim-${chipClass}${isLive ? ' is-live' : ''}${
        isPast ? ' is-past' : ''
      }${scrim.cancelled ? ' is-cancelled' : ''}${scrim.replaced ? ' is-replaced' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick && onClick(event);
        }
      }}
      title={`${chipLabel} - ${title || 'Untitled'}`}
    >
      <div className="scrim-chip-kicker">
        <span>{chipLabel}</span>
        {stateLabel && <span className="scrim-chip-state">{stateLabel}</span>}
      </div>
      <div className="scrim-chip-title">{title || 'Untitled'}</div>
      <div className="scrim-chip-time">{displayTime}</div>
      <div className="scrim-chip-details">
        {plannedContent && <div>{plannedContent}</div>}
        {opponent && <div>{opponent}</div>}
        {note && <div>{note}</div>}
      </div>
    </div>
  );
};

export default ScrimChip;
